
import Vue from 'vue';

import { mdbContainer, mdbCard, mdbBtn } from 'mdbvue';
import navbar from '@/components/navbar.vue';
import mainFooter from '@/components/main-footer.vue';

import router from '../router/index';

import store from '../store';

export default Vue.extend({
  name: 'Home',
  components: {
    mdbContainer,
    mdbCard, 
    mdbBtn,
    navbar,
    mainFooter
  },
  methods: {
    start: function() {
      router.push('name');
    },
    goToHistory() {
      router.push('history')
    }
  },
  mounted: function() {
    store.commit('INIT_PROCEDURE');
  }
});
